import { css } from '@emotion/css';
import Button, { Variations as ButtonVariations } from 'components/Button';
import React, { useState } from 'react';

import LargeHeading from 'components/LargeHeading';
import Modal from 'components/Modal';
import { customElementInteraction } from 'bindings/Segment.bs';

const wrapper = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
});

const buttonWrapper = css({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '1.5rem',
  width: '100%',
  '> button + button': {
    marginLeft: '16px',
    '@media (max-width: 640px)': {
      marginLeft: '0px',
      marginTop: '10px',
    },
  },
  '@media (max-width: 640px)': {
    flexDirection: 'column',
  },
});

const detailsWrapper = css({
  marginTop: '1.5rem',
});

interface Props {
  children?: (show: any) => React.ReactNode;
  description: string;
  title: string;
}

const GiftReminderDeleteConfirmModal = ({ children, title, description }: Props) => {
  const [open, setOpen] = useState(false);
  const [callback, setCallback] = useState(null);

  const show = (callback, tracking) => event => {
    event.preventDefault();
    if (tracking) {
      customElementInteraction(tracking);
    }
    setOpen(true);
    event = {
      ...event,
      target: { ...event.target, value: event.target.value },
    };
    setCallback({
      run: () => callback(event),
    });
  };

  const hide = () => {
    setCallback(null);
    setOpen(false);
  };

  const confirm = () => {
    callback.run();
    hide();
  };

  return (
    <>
      {children(show)}
      {open && (
        <Modal onClose={hide}>
          <div className={wrapper}>
            <h1>
              <LargeHeading>{title}</LargeHeading>
            </h1>
            <p className={detailsWrapper}>{description}</p>
            <div className={buttonWrapper}>
              <Button onClick={hide} variation={ButtonVariations.Outlined}>
                Cancel
              </Button>
              <Button onClick={confirm} variation={ButtonVariations.Primary}>
                Delete
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
export default GiftReminderDeleteConfirmModal;
